(()=>{
if(customElements.get('rgb-quick-add'))return;
class RGBQuickAdd extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.product=JSON.parse(this.querySelector('[data-qa-product]').textContent);
  this.form=this.querySelector('form');
  this.money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.product.currency||'USD'});
  this.addEventListener('change',e=>{if(e.target.matches('[data-plan]')){this.querySelector('input[value="sub"]').checked=true;}this.update();});
  this.update();this.reviews();
 }
 fmt(n){return this.money.format(n/100);}
 update(){
  const selected=this.querySelector('.rgqa-variant input:checked');
  const v=this.product.variants.find(v=>String(v.id)===selected?.value)||this.product.variants[0];
  if(!v)return;
  this.form.elements.id.value=v.id;
  const planSelect=this.querySelector('[data-plan]'),previous=planSelect?.value;
  if(planSelect){
   planSelect.replaceChildren(...v.plans.map(p=>new Option(p.name.replace(/\s+with\s+\d+%\s+discount.*$/i,''),String(p.id))));
   if(v.plans.some(p=>String(p.id)===previous))planSelect.value=previous;
   else {const preferred=v.plans.find(p=>/8 weeks|2 months/i.test(p.name));if(preferred)planSelect.value=String(preferred.id);}
   this.querySelector('[data-sub-row]').hidden=!v.plans.length;
  }
  let mode=this.querySelector('.rgqa-mode input:checked');
  if(!v.plans.length&&mode?.value==='sub'&&!this.product.requiresPlan){mode=this.querySelector('.rgqa-mode input[value="one"]');if(mode)mode.checked=true;}
  const plan=v.plans.find(p=>String(p.id)===planSelect?.value);
  const sub=mode?.value==='sub',price=sub&&plan?plan.price:v.price;
  const sp=this.form.elements.selling_plan;sp.disabled=!(sub&&plan);sp.value=sub&&plan?plan.id:'';
  const txt=(s,t)=>{const e=this.querySelector(s);if(e)e.textContent=t;};
  txt('[data-one-price]',this.fmt(v.price));txt('[data-one-compare]',v.compare>v.price?this.fmt(v.compare):'');
  if(plan){const discount=Math.round((v.price-plan.price)/v.price*100);txt('[data-sub-price]',this.fmt(plan.price));txt('[data-sub-compare]',v.price>plan.price?this.fmt(v.price):'');txt('[data-sub-saving]',discount>0?`EXTRA ${discount}% OFF`:'');txt('[data-sub-benefit]',discount>0?`EXTRA ${discount}% OFF EVERY ORDER`:'Convenient recurring deliveries');}
  const available=v.available&&(!this.product.requiresPlan||!!plan);
  this.querySelector('[data-add-to-cart]').disabled=!available;
  txt('[data-add-to-cart-text]',available?`BUY NOW ${this.fmt(price)}`:'SOLD OUT');
  const savings=Math.max(v.compare,v.price)-price;
  txt('[data-total]',savings>0?`TOTAL SAVINGS ${this.fmt(savings)}`:'');this.querySelector('[data-total]').hidden=savings<=0;
 }
 async reviews(){
  const skus=this.product.variants.map(v=>v.sku).filter(Boolean);if(!skus.length)return;
  try{
   const params=new URLSearchParams({type:'product_review',store:'rawgeneration.myshopify.com',sku:skus.join(';'),sort:'date_desc',per_page:'5',page:'1',widget:'polaris'});
   const r=await fetch(`https://api.reviews.io/timeline/data?${params}`);if(!r.ok)return;const d=await r.json();if(!this.isConnected)return;
   const rating=Number(d.stats?.average_rating),count=Number(d.stats?.review_count);if(!count||!Number.isFinite(rating))return;
   const stars=document.createElement('span');stars.className='rgqa-stars';stars.textContent='★★★★★';stars.setAttribute('aria-hidden','true');
   const caption=document.createElement('span');caption.textContent=`Rated ${rating.toFixed(1)} from ${count.toLocaleString()} reviews`;
   const header=this.querySelector('[data-rating]');header.replaceChildren(stars,caption);header.hidden=false;
   const review=d.timeline?.map(x=>x._source).find(x=>skus.includes(x.sku)&&x.comments);if(!review)return;
   const box=this.querySelector('[data-quote]'),quote=document.createElement('p'),cite=document.createElement('cite');
   const words=review.comments.trim().split(/\s+/);quote.textContent='“'+words.slice(0,24).join(' ')+(words.length>24?'…':'')+'”';
   cite.textContent='★'.repeat(Math.min(5,Math.max(0,Number(review.rating))))+' '+review.author;box.replaceChildren(quote,cite);
   if(review.tags?.some(t=>t.tag==='incentivized')){const note=document.createElement('small');note.textContent='Incentivized review';box.append(note);}box.hidden=false;
  }catch(_){}
 }
}
customElements.define('rgb-quick-add',RGBQuickAdd);
})();
